import React, { useContext, useEffect } from 'react';
import List from './List';

//Material UI
import { makeStyles } from '@material-ui/core';

//Contexts
import { store as reportStore } from '../reducer';

//Zustands
import { useOnlineUsersStore } from './useOnlineUsersStore';
import { useMainStore } from 'useStores/useMainStore';

//Hooks
import useTitle from 'hooks/useTitle';

//Components
import Filters from './Filters';
import Total from '../../../../../components/Total/Total';
import { rond } from 'fns';
import { toEN } from 'fns';
import { formatNumber } from 'fns';
import { toFA } from 'fns/toFA';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const OnlineUsers = () => {
  const classes = useStyles();
  useTitle('گزارش کاربران آنلاین');
  const totalAmount = useOnlineUsersStore((state) => state.users?.totalAmount);
  const totalOffline = useOnlineUsersStore(
    (state) => state.users?.totalOffline
  );
  const totalOnline = useOnlineUsersStore((state) => state.users?.totalOnline);
  const totalCustomers = useOnlineUsersStore((state) => state.totalCustomers);

  const { dispatch: reportDispatch } = useContext(reportStore);

  useEffect(() => {
    reportDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: '',
        category: '',
      },
    });
  }, []);

  return (
    <div className={classes.root}>
      <Filters />
      <List />
      <div className="d-flex" style={{ gap: 8, position: 'sticky', bottom: 0 }}>
        <Total total={totalCustomers} title="تعداد کل" endText="نفر" />
        <Total
          backgroundColor={'purple'}
          total={toFA(formatNumber(toEN(rond(totalAmount))))}
        />
        <Total
          backgroundColor={'yellow'}
          title="جمع کل آنلاین: "
          total={toFA(formatNumber(toEN(rond(totalOnline))))}
        />
        <Total
          backgroundColor={'red'}
          title="جمع کل سنتی: "
          total={toFA(formatNumber(toEN(rond(totalOffline))))}
        />
      </div>
    </div>
  );
};

export default OnlineUsers;
